/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Deduction_Audit_TitleInputs */

const en_cargos_deduction_audit_title = /** @type {(inputs: Cargos_Deduction_Audit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventory Deduction Audit`)
};

const es_cargos_deduction_audit_title = /** @type {(inputs: Cargos_Deduction_Audit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditoria de deducciones de inventario`)
};

/**
* | output |
* | --- |
* | "Inventory Deduction Audit" |
*
* @param {Cargos_Deduction_Audit_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_deduction_audit_title = /** @type {((inputs?: Cargos_Deduction_Audit_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Deduction_Audit_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_deduction_audit_title(inputs)
	return es_cargos_deduction_audit_title(inputs)
});